export default "__VITE_ASSET__8eea432e__"